
import React, { useEffect, useState } from "react";
import Logo from "../../assets/images/logo.png";
import { useNavigate, useLocation } from "react-router-dom";

const apiUrl =  process.env.REACT_APP_API_URL
console.log(apiUrl);

function Login() {
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log("Login component mounted");

    const handleCallback = () => {
      console.log("Handling callback");

      const urlParams = new URLSearchParams(location.search);
      const token = urlParams.get("token");
      const userString = urlParams.get("user");

      console.log("Token from URL:", token);
      console.log("User from URL:", userString);

      if (token && userString) {
        // Save the token and user in local storage or state
        localStorage.setItem("accessToken", token);

        try {
          const user = JSON.parse(decodeURIComponent(userString));
          localStorage.setItem("user", JSON.stringify(user));
        } catch (error) {
          console.error("Error parsing user data:", error);
        }

        // Navigate to the dashboard
        navigate("/dashboard");
      }
    };

    handleCallback();
  }, [location, navigate]);

  const handleLogin = () => {
    console.log("Initiating login");
    window.location.href = `${apiUrl}auth`;
  };

  const handleDevLogin = () => {
    console.log("Initiating dev login");
    window.location.href = `${apiUrl}auth/dev-login`;
  };

  const isLocal = apiUrl?.includes("localhost");

  return (
    <div className="login-container">
      <div className="login-box">
        <img src={Logo} className="logo" alt="Logo goes here" />
        <p className='mb-3'>Use your Arden login credential to login to this platform</p>
        {error && <div className="alert alert-danger" role="alert">{error}</div>}
        <button onClick={handleLogin} className="btn btn-primary w-100">
          Sign in with Arden
        </button>
        {isLocal && (
          <button onClick={handleDevLogin} className="btn btn-outline-secondary w-100 mt-2">
            Dev Login (Skip MS Auth)
          </button>
        )}
      </div>
    </div>
  );
}

export default Login;





